import { Button, Chip } from '@mui/material';
import { useController } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';
import { ConfirmDelete } from '@components';

export const UserTags = () => {
  const {
    field: { value: isRenewal, onChange: setRenewal },
  } = useController({ name: 'isRenewal' });
  const {
    field: { value: isUnqualified, onChange: setUnqualified },
  } = useController({ name: 'isUnqualified' });
  const cls = useStyles();

  const onRenewalClick = () => setRenewal(isRenewal ? false : true);
  const onUnqualifiedClick = () => setUnqualified(isUnqualified ? false : true);

  const unqualifiedTextConfirm =
    'Are you sure you want to mark this client as “unqualified”? By doing so, you are rejecting all his credits and removing any chance of new credits in the future';

  return (
    <div className={cls.box}>
      <Button className={cls.btn} onClick={onRenewalClick}>
        <Chip
          className={clsx(cls.chip, isRenewal && cls.renewal)}
          label="Eligible for Renewal"
        />
      </Button>
      {isUnqualified ? (
        <Button className={cls.btn} onClick={onUnqualifiedClick}>
          <Chip
            className={clsx(cls.chip, isUnqualified && cls.isUnqualified)}
            label="Unqualified"
          />
        </Button>
      ) : (
        <ConfirmDelete cb={onUnqualifiedClick} title={unqualifiedTextConfirm}
          overlayClassName={cls.confirmDelete}>
          <Chip
            className={clsx(cls.chip, isUnqualified && cls.isUnqualified)}
            label="Unqualified"
          />
        </ConfirmDelete>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  box: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'center',
    marginLeft: -8,
  },
  btn: {
    padding: '0',
    textTransform: 'none',
    minWidth: 'unset',
    borderRadius: 15,
  },
  chip: {
    color: 'white',
    backgroundColor: '#AAA',
    fontSize: '12px !important',
    lineHeight: '1 !important',
    cursor: 'pointer',
    height: '20px !important',
    '& > span': {
      padding: '1px 6px',
    },
  },
  renewal: {
    backgroundColor: 'var(--primary-color)',
  },
  isUnqualified: {
    backgroundColor: '#DD482E',
  },
  confirmDelete: {
    width: '300px',
    '& > div': {
      width: '100% !important',
      '& > div': {
        width: '100% !important',
        '& > div': {
          width: '100% !important',
        },
      },
    },
  },
});
